import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InsuranceStatsState } from "../objects/insurance-stats-state";

const initialState: InsuranceStatsState = {
    last_selected_month: null
};

export const insurance_stats = createSlice({
    name: 'insurance_stats',
    initialState,
    reducers: {
        setLastSelectedMonth: (state: InsuranceStatsState, action: PayloadAction<string | null>): InsuranceStatsState => ({
            ...state, last_selected_month: action.payload
        })
    }
});

export const {
    setLastSelectedMonth
} = insurance_stats.actions;